import { FolderOpen, Loader2 } from "lucide-react";

export function LoadingSkeleton() {
  return (
    <div className="space-y-3 animate-pulse">
      {[1, 2, 3, 4, 5].map((i) => (
        <div
          key={i}
          className="flex gap-4 rounded-xl border border-grid-200 bg-white p-3"
        >
          <div className="h-20 w-28 shrink-0 rounded-lg bg-grid-100" />
          <div className="flex flex-1 flex-col justify-center gap-2">
            <div className="flex gap-2">
              <div className="h-4 w-16 rounded bg-grid-200" />
              <div className="h-4 w-20 rounded bg-grid-100" />
            </div>
            <div className="h-4 w-3/4 rounded bg-grid-100" />
            <div className="h-3 w-1/3 rounded bg-grid-100" />
          </div>
        </div>
      ))}
    </div>
  );
}

export function EmptyState() {
  return (
    <div className="flex flex-col items-center justify-center rounded-xl border border-dashed border-grid-300 bg-grid-50/50 py-16">
      <FolderOpen className="h-10 w-10 text-ink-300" />
      <h3 className="mt-3 text-sm font-medium text-ink-700">No files yet</h3>
      <p className="mt-1 max-w-xs text-center text-xs text-ink-400">
        Files added to your categories will appear here. Check back soon.
      </p>
    </div>
  );
}

export function FeedEnd() {
  return (
    <div className="flex flex-col items-center py-8 text-ink-300">
      <div className="h-px w-16 bg-grid-200 mb-3" />
      <p className="text-xs">You're all caught up</p>
    </div>
  );
}

export function LoadingMore() {
  return (
    <div className="flex items-center justify-center gap-2 py-6">
      <Loader2 className="h-4 w-4 animate-spin text-imperial-400" />
      <span className="text-xs text-ink-400">Loading more…</span>
    </div>
  );
}
